import { render, staticRenderFns } from "./SubtopicSelection.vue?vue&type=template&id=28f2b616&scoped=true"
import script from "./SubtopicSelection.vue?vue&type=script&lang=js"
export * from "./SubtopicSelection.vue?vue&type=script&lang=js"
import style0 from "./SubtopicSelection.vue?vue&type=style&index=0&id=28f2b616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2b616",
  null
  
)

export default component.exports